import { render, staticRenderFns } from "./ModalLabelProduct.vue?vue&type=template&id=069c3562&scoped=true"
import script from "./ModalLabelProduct.vue?vue&type=script&lang=js"
export * from "./ModalLabelProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalLabelProduct.vue?vue&type=style&index=0&id=069c3562&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c3562",
  null
  
)

export default component.exports